export default __webpack_public_path__ + "images/52_2_image.jpg";